import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import { reactive } from "vue";
import { BrandService } from "@/services/brand.service";
import { store } from "@/stores/store";
import { UsersService } from "@/services/users.service";
import { ClientService } from "@/services/client.service";
import { router } from "@/router";
export const selectBrandDialog = reactive({
  showDialog: false,
  selectedBrandId: store.currentBrand?.id,
  selectedBrand: store.currentBrand
});
export const closeSelectBrandDialog = () => {
  selectBrandDialog.showDialog = false;
};
export const openSelectBrandDialog = () => {
  selectBrandDialog.showDialog = true;
};
export default {
  data() {
    const searchBrand = this.debounce(this.getBrands, 500);
    return {
      loading: false,
      search_loading: false,
      data_loaded: false,
      filter: {
        search_brand_name: ""
      },
      orderBy: {
        field: "brand_name",
        order: "asc"
      },
      brands: null,
      count: 0,
      store,
      searchBrand: searchBrand,
      selectBrandDialog: selectBrandDialog
    };
  },
  methods: {
    selectBrand(brand) {
      console.log(brand);
      this.selectBrandDialog.selectedBrand = brand;
      this.selectBrandDialog.selectedBrandId = brand.id;
    },
    async changeCurrentBrand() {
      this.loading = true;
      store.currentBrand = this.selectBrandDialog.selectedBrand;
      await UsersService.updateUser({
        id: store.currentUser.id,
        current_brand_id: this.selectBrandDialog.selectedBrand.id
      });
      this.$toast.add({
        severity: "success",
        summary: "Success",
        detail: "Brand changed successfully",
        life: 5000
      });
      router.push({
        name: "index"
      });
      closeSelectBrandDialog();
      this.loading = false;
    },
    async getBrands() {
      this.search_loading = true;
      let current_user_type = store.currentUser.user_type;
      if (current_user_type == "staff") {
        const {
          data,
          count,
          error
        } = await BrandService.getBrands(this.filter, this.orderBy, 0);
        if (error) {
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: error,
            life: 5000
          });
        } else {
          if (data) {
            this.brands = data;
          } else {
            this.brands = null;
          }
          this.count = count;
        }
      } else {
        const {
          client,
          error
        } = await ClientService.getClient(store.currentUser.id);
        if (error) {
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: error,
            life: 5000
          });
        }
        if (client) {
          let client_brands = client.client_brands;
          if (client_brands.length == 0) {
            this.brands = null;
          } else {
            this.brands = client_brands.map(client_brand => {
              return client_brand.brand;
            });
            this.count = this.brands.length;
          }
        }
      }
      this.search_loading = false;
      this.data_loaded = true;
    },
    debounce(func, delay) {
      let timerId;
      return function (...args) {
        if (timerId) {
          clearTimeout(timerId);
        }
        timerId = setTimeout(() => {
          func.apply(this, args);
          timerId = null;
        }, delay);
      };
    }
  },
  watch: {
    "selectBrandDialog.showDialog": {
      handler: async function (val) {
        if (val) {
          this.filter.search_brand_name = "";
          this.data_loaded = false;
          await this.getBrands();
          this.selectBrandDialog.selectedBrandId = store.currentBrand?.id;
          this.selectBrandDialog.selectedBrand = store.currentBrand;
        }
      },
      immediate: true
    }
  }
};